import SearchHotelsFilterInput from '@app/model/flexi_sets/input/SearchHotelsFilterInput';
import React from 'react';
import FormButton from '@app/component/form/button/FormButton';
import FlexiSetGenericFilterFragment
	from '@app/site/secured/rateshopper/rates/dashboard/fragment/__flexi-sets/fragment/filter/FlexiSetGenericFilterFragment';
import {
	averageNightRangeRangeConfig,
	bathroomsFilterConfig,
	bedroomsFilterConfig,
	guestsFilterConfig,
	isSuperhostConfig,
	ratingRangeConfig, reviewsCountRangeConfig,
} from '@app/site/secured/rateshopper/rates/dashboard/fragment/__flexi-sets/fragment/filter/FlexiSetFilterConfigs';
import FlexiSetGenericBooleanFilterFragment
	from '@app/site/secured/rateshopper/rates/dashboard/fragment/__flexi-sets/fragment/filter/FlexiSetGenericBooleanFilterFragment';
import FlexiSetGenericRangeFilterFragment
	from '@app/site/secured/rateshopper/rates/dashboard/fragment/__flexi-sets/fragment/filter/FlexiSetGenericRangeFilterFragment';
import SearchHotelWithinRadiusResult from '@app/model/flexi_sets/SearchHotelWithinRadiusResult';


const FlexiSetFiltersFragment: React.FunctionComponent<{
	areaHotels: SearchHotelWithinRadiusResult[],
	filter: SearchHotelsFilterInput,
	onFilter: (filter: SearchHotelsFilterInput) => void,
	onAddToSet: () => void,
	onShowListings: () => void,
}> = ({ areaHotels, filter, onFilter, onShowListings, onAddToSet }) => {

	return <div className="rounded-lg bg-white size-full shadow px-5 py-8 max-h-[300px] md:max-h-[calc(100vh_-_300px)] overflow-auto">
		<div className="space-y-8">
			<div className="wrapper space-y-2">
				<header className="relative flex justify-between items-center group">
					<p className="text-sm font-semibold text-gray-900 group-hover:cursor-pointer">Listing count</p>
				</header>
				<div className="space-y-1 text-sm text-gray-600"><p
					className="text-xl font-semibold tracking-tight text-gray-900">{areaHotels.length}</p></div>
				<div className="flex flex-wrap gap-x-3 gap-y-1">
					<FormButton state="primary" extraClassName="text-xs py-1.5" onClick={onAddToSet}>Add to Set</FormButton>
					<FormButton state="white" extraClassName="text-xs py-1.5" onClick={onShowListings}>View listing</FormButton>
				</div>
			</div>
			<FlexiSetGenericFilterFragment
				areaHotels={areaHotels}
				filter={filter}
				onFilter={onFilter}
				config={bedroomsFilterConfig}
			/>
			<FlexiSetGenericFilterFragment
				areaHotels={areaHotels}
				filter={filter}
				onFilter={onFilter}
				config={bathroomsFilterConfig}
			/>
			<FlexiSetGenericFilterFragment
				areaHotels={areaHotels}
				filter={filter}
				onFilter={onFilter}
				config={guestsFilterConfig}
			/>
			<FlexiSetGenericBooleanFilterFragment
				areaHotels={areaHotels}
				filter={filter}
				onFilter={onFilter}
				config={isSuperhostConfig}
			/>
			<FlexiSetGenericRangeFilterFragment
				areaHotels={areaHotels}
				filter={filter}
				onFilter={onFilter}
				config={ratingRangeConfig}
			/>
			<FlexiSetGenericRangeFilterFragment
				areaHotels={areaHotels}
				filter={filter}
				onFilter={onFilter}
				config={reviewsCountRangeConfig}
			/>

			<FlexiSetGenericRangeFilterFragment
				areaHotels={areaHotels}
				filter={filter}
				onFilter={onFilter}
				config={averageNightRangeRangeConfig}
			/>
		</div>
	</div>;

};

export default FlexiSetFiltersFragment;